import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, Input, output, viewChild } from '@angular/core'

import { BlobPlayerDirective } from '@app/directives/blob-player.directive'
import type { Message } from '@app/modules/messaging/models/message.model'
import { UIModule } from '@app/modules/ui/ui.module'

import { VoiceMessageProgressBarComponent } from '../voice-message-progress-bar/voice-message-progress-bar.component'

@Component({
  selector: 'sb-voice-message-player',
  templateUrl: './voice-message-player.component.html',
  imports: [CommonModule, UIModule, VoiceMessageProgressBarComponent, BlobPlayerDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VoiceMessagePlayerComponent {
  readonly playVoiceMessage = output<void>()

  @Input({ required: true }) message!: Message & { type: 'voice'; status: 'viewable' }
  @Input({ required: true }) theme!: 'light' | 'dark'

  readonly player = viewChild.required(BlobPlayerDirective)

  readonly progress = computed(() => {
    const currentTime = this.player().currentTime()
    const duration = this.player().duration()

    if (duration > 0) {
      return (currentTime / duration) * 100
    }

    return 0
  })

  readonly timer = computed(() => {
    return this.player().currentTime() || this.message.voice_message.duration! * 1000
  })

  togglePlayPause(): void {
    if (this.player().playing()) {
      this.player().pause()
    } else {
      this.player().play()

      if (this.player().currentTime() === 0) {
        this.playVoiceMessage.emit()
      }
    }
  }
}
